import { Image } from "@/components/Image";
import { dayjs } from "@/lib/dayjs";
import { formatPrice } from "@/lib/formatPrice";
import type { SearchTravel } from "front-search-schema/algolia";
import Link from "next/link";

type Props = {
  travel: SearchTravel;
};
export const Journey = ({ travel }: Props) => {
  const departure = travel.departures[0];

  if (!departure) return null;

  const speaker = departure.speakers?.[0];
  const image = travel.travelImages[0];

  return (
    <Link
      href={`/voyage/${travel.alias || ""}-${travel.id}/${departure.id}/`}
      className="no-underline drop-shadow-sm bg-white text-primary flex flex-col items-center group"
    >
      <div className="h-24 w-full relative">
        <div className="overflow-hidden absolute top-0 right-0 bottom-0 left-0">
          <Image
            className="group-hover:scale-105 transition-all"
            sizes="360px"
            height={{
              type: "ratio",
              value: 66.66,
            }}
            alt={image?.caption || ""}
            image={{
              type: "travel",
              id: travel.id.toString(),
              name: image?.name || "",
              realname: image?.realname || "",
            }}
          />
        </div>
        <p className="absolute -bottom-[14px] bg-[#195A88] text-white left-1/2 -translate-x-1/2 whitespace-nowrap w-44 py-2 text-center uppercase text-[10px] leading-3 font-semibold">
          Journée culturelle
        </p>
      </div>
      <p className="text-[10px] leading-3 font-semibold mt-5 text-center">
        {`Le ${dayjs(departure.dateStart).format("DD MMM YYYY")}`}
      </p>
      <p className="text-base leading-5 font-semibold line-clamp-2 h-[40px] text-center mt-2">{travel.title}</p>
      {speaker && speaker.id !== 1 && (
        <p className="text-[10px] leading-3 text-center line-clamp-1 mt-2 uppercase">{`Avec ${speaker.firstname} ${speaker.lastname}`}</p>
      )}
      <div className="grow" />
      <div className="mt-2 mb-3 text-primary border border-primary rounded-sm text-[10px] leading-3 font-semibold uppercase py-2 w-52 text-center">
        {`à partir de ${formatPrice(
          departure.primoPrice ? departure.defaultPrice - departure.primoPrice : departure.defaultPrice,
        )}`}
      </div>
    </Link>
  );
};
